import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalNotesComponent } from './external-notes.component';
import { FormsModule } from '@angular/forms';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [ExternalNotesComponent],
  imports: [
    CommonModule,
    FormsModule,
    AiAssistantModule
  ],
  entryComponents: [ExternalNotesComponent],
  exports: [ExternalNotesComponent]
})
export class ExternalNotesModule { }
